import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { CenterLocalOrganizer } from '../../../lib/types/models/center/center-local-organizer'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterLocalOrganizers(id: number, query: PaginationRequest = {}) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.centers.getCenterLocalOrganizers.url, { id }), query)
    )
    .get<PaginationResponse<CenterLocalOrganizer>>()
}
